import { ContactData } from "../../../sanity/lib/queries/getNavigationData";
import { LinkElement } from "../link/link";
import { LocalizedLink } from "../link/localizedLink";

export const ContactLink = ({
    contactData,
    onToggleMenu,
}: {
    contactData: ContactData;
    onToggleMenu: () => void;
}) => {
    return (
        <div className="md:absolute md:bottom-8 right-6 ml-4.5 md:mx-0 md:pb-10 self-end">
            <LocalizedLink
                slug={contactData.contactLink?.internal?.metadata?.slug.current ?? ""}
                aria-label={
                    contactData.contactLink?.label
                        ? `Zur Seite: ${contactData.contactLink.label}`
                        : undefined
                }
                onClickHandler={() => {
                    onToggleMenu();
                }}
                className="relative flex items-center gap-2 border btn"
                label={
                    <>
                        {contactData.contactLink?.label}
                        <svg
                            className="w-6 h-6"
                            width="36"
                            height="37"
                            viewBox="0 0 36 37"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g>
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M13.5006 6.875H29.6256V21.7812H27.3756V10.716L8.29607 29.7955L6.70508 28.2045L25.7846 9.125H13.5006V6.875Z"
                                    fill="black"
                                />
                            </g>
                        </svg>
                    </>
                }
            />
        </div>
    );
};
